// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.pit-document-frame[data-v-3ee0d396] {\n    width: 100%;\n    min-height: 480px;\n    border: 1px solid rgba(0, 0, 0, 0.12);\n    border-radius: 4px;\n    background-color: #fff;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
